/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Prev_Error_Aria_LabelInputs */

const en_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous error`)
};

const fr_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller a l'erreur precedente`)
};

const de_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum vorherigen Fehler zurückkehren`)
};

const it_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'errore precedente`)
};

const ru_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к предыдущей ошибке`)
};

const es_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al error anterior`)
};

const zh_cn2_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回上一个错误`)
};

const ja_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のエラーへ移動`)
};

const hi_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली त्रुटि पर जाएं`)
};

const pt_pt2_error_nav_prev_error_aria_label = /** @type {(inputs: Error_Nav_Prev_Error_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao erro anterior`)
};

/**
* | output |
* | --- |
* | "Go to previous error" |
*
* @param {Error_Nav_Prev_Error_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_prev_error_aria_label = /** @type {((inputs?: Error_Nav_Prev_Error_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Prev_Error_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_prev_error_aria_label(inputs)
	if (locale === "de") return de_error_nav_prev_error_aria_label(inputs)
	if (locale === "it") return it_error_nav_prev_error_aria_label(inputs)
	if (locale === "ru") return ru_error_nav_prev_error_aria_label(inputs)
	if (locale === "es") return es_error_nav_prev_error_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_prev_error_aria_label(inputs)
	if (locale === "ja") return ja_error_nav_prev_error_aria_label(inputs)
	if (locale === "hi") return hi_error_nav_prev_error_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_prev_error_aria_label(inputs)
	return en_error_nav_prev_error_aria_label(inputs)
});